import React from 'react'
import { AppFormDrawer } from '@components'

import { isEmpty } from '@ui-seeker/utils'
import { batch, useComputed } from '@preact/signals-react'
import { formData } from '@signals'
import { mappingType, selectedMappingId } from 'Pages/Admin/AdminMapping/@signals'
import { MAPPING_TYPE } from 'Pages/Admin/AdminMapping/@constants'
import AdminMappingDrawerFooter from 'Pages/Admin/AdminMapping/EditDrawer/Footer'
import AdminMappingDrawerContent from 'Pages/Admin/AdminMapping/EditDrawer/Content'

export default function EditMappingDrawer() {

	const isDataEmpty = useComputed(() => isEmpty(formData.value))

	if (isDataEmpty.value) return null

	return <AppFormDrawer
		icon="diagram-project"
		title={mappingType.value === MAPPING_TYPE.ACRISS ? 'Custom Acriss Mapping' : 'Custom Categories Mapping'}
		subtitle="Where it applies and the vehicle it maps"
		width={640}
		isOpen={!isDataEmpty.value}
		controller={() => batch(() => {
			formData.value = {}
			selectedMappingId.value = null
		})}
		footer={<AdminMappingDrawerFooter/>}
	>
		<AdminMappingDrawerContent/>
	</AppFormDrawer>

}